import { useContext } from "react";
import { SignUpService } from "@/features/user/services/sign-up-service";
import { useNavigate } from "react-router-dom";
import { EndpointPathNames } from "@/shared/config/endpoint-path";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { MoneyLinkWarning } from "@/shared/utils/custom-exception";
import { ErrorDialogContext } from "@/shared/context/error-context";

export const useFirstAuthCompleted = () => {
  const signUpService = new SignUpService();
  const navigate = useNavigate();

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);
  const { setError } = useContext(ErrorDialogContext);

  const activateUser = async (token: string) => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await signUpService.activate({
        token: token
      });
      return res.owner_id;
    } catch (error) {
      if (error instanceof MoneyLinkException) {
        const {messageBody} = error.error.props;
        setError(new MoneyLinkWarning({
          title: "エラー",
          message: messageBody
        }));
        navigate(EndpointPathNames.LOGIN);
        return;
      } else {
        throw MoneyLinkException.wrapCallback(error, () => {/**intentionally empty */});
      }
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    activateUser,
  };
};
